module.exports = __webpack_public_path__ + "img/device.38c39803.png";